import { render, staticRenderFns } from "./Movimenti.vue?vue&type=template&id=375b25f3&scoped=true&"
import script from "./Movimenti.vue?vue&type=script&lang=js&"
export * from "./Movimenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b25f3",
  null
  
)

export default component.exports